var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tpanel"},_vm._l((_vm.sortedTasks),function(task){return _c('div',{key:task.id,class:['tpanel__task', {'tpanel__task--done': task.status === 'DONE'}]})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }